import jwtDecode from 'jwt-decode'
import { toast } from 'react-toastify'

import { roles } from 'utils/constants/roles'

export function getScreenByToken(token) {
  const { sub } = jwtDecode(token)
  return sub
}

export const verifyTokenRole = (token, history, redirect, state) => {
  if (token) {
    const identity = getScreenByToken(token)
    
    const { screen, data } = identity
    
    let state_ = state
    
    switch (screen) {
      case roles.DOCUMENT_OCR:
        if (data && data.type) {
          return history.replace({
            pathname: '/ocr-upload',
            state: { type: data.type },
          })
        }
        return history.replace({
          pathname: '/ocr',
          state,
        })
      case roles.DOCUMENT_OCR_RETRY:
        if (data && data.type) state_ = { type: data.type, ...state }

        return history.replace({
          pathname: '/ocr-fail',
          state: state_,
        })
      case roles.LIVENESS:
        return history.replace('/liveness')
      case roles.LIVENESS_RETRY:
        return history.replace('/liveness-fail')
      case roles.EMAIL_VALIDATION:
        return history.replace({
          pathname: '/email',
          state: state,
        })
      case roles.QUIZ:
        return history.replace('/quiz-start')
      case roles.FINISH:
      case roles.PROCESS_FAILED:
        return history.replace({
          pathname: '/result',
          state: {
            ...state,
            redirect: redirect,
          },
        })
      default:
        return history.replace('/')
    }
  } else {
    return toast.error('Token inválido')
  }
}
